<!-- 人才政策文章卡片 组件 -->
<template>
  <a :href="to" class="group" target="_blank">
    <div
      class="relative flex h-[264px] items-center rounded-3xl bg-no-repeat px-[55px] py-[31px] hover:shadow-sm lt-lg:flex-wrap lt-lg:h-auto"
      :style="{ background: `#f8f9fd url(${this.$getImageSrc('post-view-card-bg.png')}) no-repeat bottom` }"
    >
      <div class="flex w-[270px] items-center justify-center lt-lg:w-full">
        <img :src="$getImageSrc(RECRUIT_CATAGORY_ICON[title])" alt="" />
      </div>
      <el-divider direction="vertical" class="!h-full lt-lg:!hidden"></el-divider>
      <p class="ml-[70px] flex flex-col lt-lg:ml-0">
        <span class="mb-[31px] text-[24px] text-[#313131]">{{ title }}</span>
        <span class="text-[#818181]">{{ count }}个在招职位</span>
      </p>
      <!-- <div class="ml-[43px] flex h-full flex-1 flex-col pb-[43px] pt-[10px]">
      <router-link
        :to="`/pos-detail?id=${item.id}`"
        class="mb-[20px] text-[#4a4a4a] hover:text-[#1267d3]"
        v-for="item in listData.data"
        :key="item.id"
      >
        {{ item.title }}
      </router-link>
      </div> -->
      <span class="absolute bottom-[35px] right-[33px] flex items-center text-[#1267d3]">
        查看更多职位
        <Icon icon="bi:arrow-right" class="relative left-[5px] text-[20px] transition-all group-hover:left-[10px]" />
      </span>
    </div>
  </a>
</template>

<script>
import { Icon } from '@iconify/vue2';
import { RECRUIT_CATAGORY_ICON } from '@/utils/store';

export default {
  name: 'PosViewCard2',
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      default: '标题',
    },
    to: {
      type: String,
      default: '#',
    },
    count:{
      type: String,
      default: '0',
    }
  },
  data(){
    return {
      RECRUIT_CATAGORY_ICON,
    }
  }
};
</script>

<style lang="scss" scoped></style>
